import Dexie from 'dexie';

export const db = new Dexie('sme-scoring');
db.version(1).stores({
   app_state: '++id, app_state, game_state, match_id, sport_type',
   matches: '++id, sport, match_state, settings, synced',
   clocks: 'clock_id, clock',
   account: 'id, user_id, username, user_img, ad_1, ad_2, ad_3, timestamp',
   club: 'id,club_id, club_name, club_logo,timestamp',
   sync: 'id, device_id, ccfg_id, court_name, court_image',
   settings: '++setting_id, sport, free_app',
});



// db.version(2).stores({
//    app_state: '++id, app_state, game_state, match_id',
//    matches: '++id, sport, match_state, settings',
// }).upgrade (trans => {
//    console.log('*-----Trans: ', trans)
//    trans.db.delete();
//    // var YEAR = 365 * 24 * 60 * 60 * 1000;
//    // return trans.table("friends").toCollection().modify (friend => {
//    //     friend.birthdate = new Date(Date.now() - (friend.age * YEAR));
//    //     delete friend.age;
//    // });
// });